const QueryType = {
    InsertOrUpdate: 'InsertOrUpdate',
    Select: 'Select',
    Delete: 'Delete'
};

export default QueryType;
